import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import EmpresaTable from './components/EmpresaTable';
import EmpresaToolbar from './components/EmpresaToolbar/EmpresaToolbar';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { NotFound as NotFoundView } from '../index';
import { isAuthenticated } from '../../helpers/authenticate';



const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  divFab:{
    zIndex: 2
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));
function EmpresaList({history}) {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [empresas, setEmpresas] = useState({
    result: []
  });
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [showDialogConfirmacaoDeleteEmpresa, setShowDialogConfirmacaoDeleteEmpresa] = useState(false);
  const [selectedEmpresaIndex, setSelectedIndexEmpresa] = useState(-1);
  const [cnpjConfirmation, setCnpjConfirmation] = useState('');
  const [sucess, setSucess] = useState(true);

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  useEffect(() => {
    async function carregarEmpresas() {
      try{
        setLoading(true);
        const params = {
          limit: 100,
        };
        const dados = await api.get('empresas/', {params: params});
        setLoading(false);
        if(dados.data.isSuccess){
          if(dados.data.result.length !== 0){
            for(let i = 0, size = dados.data.result.length; i < size; i++){
              dados.data.result[i].on_mouse_over = false;
            }
            setEmpresas(dados.data);
          }
          else{
            setLoading(false);
            setTypeSnack('warning');
            setMessageSnack('Não há empresas cadastradas');
            setShowMessageSnack(true);
          }
        }
        else{
          setSucess(false);
        }

      }
      catch (e) {
        setSucess(false);

      }
    }
    carregarEmpresas();
  }, []);

  async function carregarEmpresas() {
    try{
      setLoading(true);
      const params = {
        limit: 100,
      };
      const dados = await api.get('empresas/', {params: params});
      setLoading(false);
      if(dados.data.isSuccess){
        for(let i = 0, size = dados.data.result.length; i < size; i++){
          dados.data.result[i].on_mouse_over = false;
        }
        setEmpresas(dados.data);
      }
      else{
      }

    }
    catch (e) {
      console.log(e.toString())
    }
  }

  function showConfirmationDeleteEmpresa(index){
    if (selectedEmpresaIndex < 0 && selectedEmpresaIndex >= empresas.result.length) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi possível deletar a empresa');
      setShowMessageSnack(true);
    }
    else{
      setSelectedIndexEmpresa(index);
      setShowDialogConfirmacaoDeleteEmpresa(true);
    }

  }

  async function deleteEmpresa() {
    if (selectedEmpresaIndex < 0 && selectedEmpresaIndex >= empresas.result.length) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi possível deletar a empresa');
      setShowMessageSnack(true);
    }
    else{
      if(cnpjConfirmation !== empresas.result[selectedEmpresaIndex].cnpj){
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack('CNPJ informado não corresponde com o da empresa que está tentando deletar');
        setShowMessageSnack(true)

      }
      else{
        try {
          setShowDialogConfirmacaoDeleteEmpresa(false);
          setLoading(true);
          const id = empresas.result[selectedEmpresaIndex].idEmpresa;
          const dados = await api.delete(`empresas/${id}`);
          setCnpjConfirmation('');
          if (dados.data.isSuccess === true) {
            const params = {
              limit: 100,
            };
            const dados = await api.get('empresas/', { params: params });
            setLoading(false);
            if (dados.data.isSuccess === true) {
              setTypeSnack('success');
              setMessageSnack('Empresa deletada com sucesso');
              setShowMessageSnack(true);
              for (let i = 0, size = dados.data.result.length; i < size; i++) {
                dados.data.result[i].on_mouse_over = false;
              }
              setEmpresas(dados.data);
            } else {
              setTypeSnack('error');
              setMessageSnack('Erro ao carregar empresas');
              setShowMessageSnack(true);
            }
          } else {
            setTypeSnack('error');
            setMessageSnack('Erro ao deletar empresa');
            setShowMessageSnack(true);
            console.log('erro delete');
          }

        } catch (e) {
          setCnpjConfirmation('');
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack('Erro ao deletar empresa');
          setShowMessageSnack(true);
        }
      }

    }
  }

  function onCancelDeleteEmpresa() {
    setSelectedIndexEmpresa(-1);
    setShowDialogConfirmacaoDeleteEmpresa(false)
  }

  async function filterEmpresas(filterValue) {
    try {
      setLoading(true);
      const params = {
        limit: 100,
        razaoSocial: filterValue,
        nomeFantasia: filterValue,
        cnpj: filterValue
      };
      const dados = await api.get('empresas/filter', { params: params });
      setLoading(false);
      if (dados.data.isSuccess) {
        for (let i = 0, size = dados.data.result.length; i < size; i++) {
          dados.data.result[i].on_mouse_over = false;
        }
        setEmpresas(dados.data);
      } else {
      }

    } catch (e) {
      console.log(e.toString())
    }
  }

  function openEmpresaRegister() {
    const empresa = {
      razaoSocial: '',
      nomeFantasia: '',
      cnpj: '',
      cnae: '',
      inscricaoEstadual: '',
      inscricaoMunicipal: '',
      email: '',
      enderecos: [],
      telefones: [],
      usuarios: []
    };
    history.push('/empresa-register/', {empresa: empresa, edicao: false});
  }

  async function openEmpresaEdit(index) {
    try{
      if (index < 0 && index >= empresas.result.length) {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack('Não foi possível editar a empresa');
        setShowMessageSnack(true);
      } else {
        setLoading(true);
        const dados = await api.get(`empresas/${empresas.result[index].idEmpresa}`);
        setLoading(false);
        if(dados.data.isSuccess){
          if(dados.data.result.length > 0){
            history.push('/empresa-edit/', {empresa: dados.data.result[0], edicao: true});
          }
          else{
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack('Ocorreu um erro ao obter dados da empresa.');
            setShowMessageSnack(true);
          }
        }
        else{
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack('Ocorreu um erro ao obter dados da empresa.');
          setShowMessageSnack(true);
        }
      }
    }
    catch (e) {
      setSucess(false);
    }
  }


  return (
    sucess
    ?
      <div
        className={classes.root}
      >
        <EmpresaToolbar
          filterEmpresas={filterEmpresas}
        />
        <SnackbarCustom
          verticalOrientation='bottom'
          horizontalOrientation='center'
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />
        <Dialog open={showDialogConfirmacaoDeleteEmpresa} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Remoção de empresa</DialogTitle>
          <DialogContent>
            <Typography gutterBottom>
              Você está tentando deletar a empresa com as seguintes informações:
            </Typography>
            <Typography
              gutterBottom
              style={{marginTop: '30px'}}
            >
              {selectedEmpresaIndex < 0 || selectedEmpresaIndex >= empresas.result.length ? '' :
                'Razão Social: ' + empresas.result[selectedEmpresaIndex].razaoSocial
              }
            </Typography>
            <Typography
              gutterBottom
              style={{marginBottom: '30px'}}

            >
              {selectedEmpresaIndex < 0 || selectedEmpresaIndex >= empresas.result.length ? '' :
                'CNPJ: ' + empresas.result[selectedEmpresaIndex].cnpj
              }
            </Typography>
            <Typography gutterBottom>
              Para confirmar a exclusão, por favor digite novamente o CNPJ da empresa
            </Typography>
            <TextField
              autoFocus
              margin="dense"
              variant={'outlined'}
              id="cnph_confirmation"
              label="CNPJ"
              type="text"
              fullWidth
              onChange={e => setCnpjConfirmation(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancelDeleteEmpresa} color="primary">
              Cancel
            </Button>
            <Button onClick={deleteEmpresa} color="primary">
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
        <div className={classes.content}>
          <ProgressFullScreen
            open={loading}
            setOpen={setLoading}
          />


          <EmpresaTable
            empresas={empresas}
            setEmpresas={setEmpresas}
            deleteEmpresa={showConfirmationDeleteEmpresa}
            editEmpresa={openEmpresaEdit}
            showMessageSnack={showMessageSnack}
            setShowMessageSnack={setShowMessageSnack}
            messageSnack={messageSnack}
            setMessageSnack={setMessageSnack}
            typeSnack={typeSnack}
            setTypeSnack={setTypeSnack}
          />
        </div>
        <div
          className={classes.divFab}

        >
          <Fab
            aria-label={'Add'}
            className={classes.fab}
            color={'primary'}
            variant={'round'}
            onClick={openEmpresaRegister}
          >
            <AddIcon />
          </Fab>
        </div>
      </div>
      :
      <NotFoundView/>

  );
};

export default EmpresaList;
